import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, formatApiErrorDetail, setAccessToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((response) => setUser(response.data))
      .catch(() => setUser(false));
  }, []);

  const value = useMemo(
    () => ({
      user,
      login: async (email, password) => {
        try {
          const response = await api.post("/auth/login", { email, password });
          const { access_token: accessToken, ...authUser } = response.data;
          setAccessToken(accessToken);
          setUser(authUser);
          return authUser;
        } catch (error) {
          throw new Error(formatApiErrorDetail(error.response?.data?.detail) || error.message);
        }
      },
      logout: async () => {
        try {
          await api.post("/auth/logout");
        } finally {
          setAccessToken(null);
          setUser(false);
        }
      },
    }),
    [user],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
